export { BasicsPage as default } from '@/components/pages/Ir/Governance/Basics'
